module.exports = __webpack_public_path__ + "static/media/acuarela-testimonios.c7fbc738.png";